<template>
<div class="chapter">
<div class="inner_page">
<h2 class="heading-old">ON BOARD THE CITACELESTE</h2>
<p class="first-paragraph-old">7. Farouk’s Apartments</p>
<p class="first-paragraph-old">6. Gynaeceum</p>
<p class="first-paragraph-old">5. Jetty-Promenade</p>
<p class="first-paragraph-old">4. Family Opera House</p>
<p class="first-paragraph-old">3. Thermal Baths</p>
<p class="first-paragraph-old">2. Hanging Gardens</p>
<p class="first-paragraph-old">1. Council of Ministers’ Hall</p>
<p class="first-paragraph-old">0. Embassy of Clairdelune</p>
<p class="first-paragraph-old"> </p>
<p class="first-paragraph-old">a. Treasury</p>
<p class="first-paragraph-old">b. Police Station</p>
<p class="first-paragraph-old">c. Workshop of Hildegarde &amp; Co.</p>
<div style="text-align:center;"><img alt="map" height="99%" src="map.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// EE_DABOS_CLAIRDELUNE_ebk_00005.vue?2cdb8357